import { apiServer } from './index';

export function saveNominationForm(data) {
  return apiServer({
    url: '/awards/nomination',
    method: 'post',
    data: JSON.stringify(data),
  });
}
